var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('button',{ref:"btn",staticClass:"btn bg-primary",staticStyle:{"font-size":"18px"},on:{"click":_vm.login}},[_vm._v("\n    "+_vm._s(_vm.t('login.loginWithProvider', {provider: _vm.displayName}))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }